module.exports = __webpack_public_path__ + "static/img/wdjc1-1.dc6f5c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdjc1-1.png
// module id = 880
// module chunks = 0